import * as React from 'react';
import { t } from '../../../../services/HelperService';
import {
  CardHeader,
  Chip,
  ChipRow,
  MetaRow,
  ReferenceRow,
  isPastDate,
  money,
  shortDate,
  translateKey,
} from './builtInCardParts';

export const JobLineBuiltInCard = ({ card, data }) => {
  const isOpen = (data.Status ?? '') === 'status_job_line_open';
  const etaOverdue = isOpen && isPastDate(data.ETA);
  const hasDims = data.Width || data.Drop;

  return (
    <div>
      <CardHeader
        title={data.ProductName || card.description}
        subTitle={<ReferenceRow reference={data.JobReference} linked={data.JobLineNo} />}
      />
      <ChipRow>
        {data.Qty != null && <Chip tone="green">{t('Qty')} {data.Qty}</Chip>}
        {hasDims && <Chip tone="gray">{data.Width ?? '?'} x {data.Drop ?? '?'}</Chip>}
        {data.Stage && <Chip tone="blue">{translateKey(data.Stage)}</Chip>}
        {data.DispatchStage && <Chip tone="amber">{translateKey(data.DispatchStage)}</Chip>}
      </ChipRow>
      {data.ContactName && <MetaRow icon="person">{data.ContactName}</MetaRow>}
      {data.ETA && (
        <MetaRow icon="schedule" danger={etaOverdue}>
          {t('ETA')} {shortDate(data.ETA)}{etaOverdue ? ` · ${t('overdue')}` : ''}
        </MetaRow>
      )}
      <MetaRow icon="place" right={money(data.SalePriceIncTax)}>
        {[data.Location, data.Suburb].filter(Boolean).join(' · ')}
      </MetaRow>
      {data.SupplierName && <MetaRow icon="local_shipping">{data.SupplierName}</MetaRow>}
    </div>
  );
};
